<template>
  <m-input-select
    :label="this.$t('common.currency')"
    :options="currencyOptions"
    :help-danger="helpDanger"
    :value="currencies[0]"
    :disabled="disabled"
    :fullwidth="fullwidth"
    @input="handleCurrencySelect"
  />
</template>

<script>
  import { MInputSelect } from 'codefabrik-gui-vue'

  export default {
    name: 'CurrencySelect',
    components: { MInputSelect },
    props: {
      helpDanger: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      fullwidth: Boolean,
      nullable: Boolean,
      nullableLabel: {
        type: String,
        default () { return this.$t('common.all') }
      }
    },
    computed: {
      currencies() {
        return [this.nullableLabel, "EUR", "USD", "COINS"]
      },
      currencyOptions () {
        return this.currencies.map(it => {
          return { value: it, label: it }
        })
      },
    },
    methods: {
      handleCurrencySelect (newValue) {
        if(newValue === this.$t('common.all')){
          this.$emit('input', null);
          return;
        }
        this.$emit('input', newValue)
      },
    },
  }
</script>

<style scoped>

</style>
